import React from 'react';
import Layout from '@/components/Layout';
import { GlassCard } from '@/components/ui/glass-card';
import { Trophy, Award, Star, TrendingUp } from 'lucide-react';

export default function AchievementsPage() {
  const achievements = [
    { icon: Trophy, title: '96% Board Result', desc: 'Outstanding performance in board examinations', color: 'bg-amber-100 text-amber-700' },
    { icon: Award, title: '24 Students Above 80%', desc: 'Excellence in academic performance', color: 'bg-blue-100 text-blue-700' },
    { icon: Star, title: 'Scholarship Program', desc: 'Supporting meritorious students', color: 'bg-green-100 text-green-700' },
    { icon: TrendingUp, title: 'Leadership Program', desc: 'Developing future leaders', color: 'bg-purple-100 text-purple-700' }
  ];

  return (
    <Layout>
      <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-950 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">Our Achievements</h1>
          <p className="text-xl text-blue-100">Celebrating excellence and success</p>
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {achievements.map((item, i) => (
              <GlassCard key={i}>
                <div className={`w-16 h-16 ${item.color} rounded-2xl flex items-center justify-center mb-4`}>
                  <item.icon className="w-8 h-8" />
                </div>
                <h3 className="text-xl font-bold text-blue-900 mb-2">{item.title}</h3>
                <p className="text-slate-600">{item.desc}</p>
              </GlassCard>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
